import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { getData } from "../Redux/app/action";
import ImgCard from "../Components/ImgCard";


const Cards = () => {
 
  const dispacth = useDispatch();

  const { isLoading, cards,isError } = useSelector((store) =>{return { isLoading:store.appReducer.isLoading,cards:store.appReducer.cards,isError:store.appReducer.isError } })

  // const cards = useSelector((store) => store.appReducer.cards);

  const [searchParams] = useSearchParams();
  const location = useLocation();
  useEffect(() => {
    
    if (location || cards.length === 0) {
      const queryParams = {
        params: {
          category: searchParams.getAll("category"),
        },
      };
      dispacth(getData(queryParams));
    }
    console.log(cards);
  }, [location.search]);

  return (
    
    <>
      {isLoading && <div>...loading</div>}
      {isError && <h1>No Internet Connection</h1>}
      {cards.length > 0 &&
        cards.map((data) => {
          return (
<div>
            {/* <CardWrapper key={data.id}>
              <div>
                <img src={data.banner} alt={data.quote} style={{width:"100%"}}/>
              </div>
              <h3>{data.quote}</h3>
              <br/>
              <div style={{display:"flex",marginRight:"5px",gap:"10px",marginLeft:"10px"}}>
              <img src={data.beneficiaryLogo} alt="" style={{borderRadius:"100px",height:"50px",width:"50px"}} />
                <h6 style={{marginTop:"15px"}}>by {data.beneficiary}</h6>
              </div>
              <h2 style={{textAlign:"left"}}>{data.raised} raised</h2>
              <div style={{display:"flex",justifyContent:"space-around"}}>
                <h4>{data.days}</h4>
                <h4>{data.supporters}</h4>
              </div>

              </CardWrapper> */}
            <div key={data.id} style={{boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"}}>
              <Link to={`/fundraiserDetails/${data.id}`}>
                  <ImgCard {...data} />
                </Link>
              </div>
              </div>
              ) 

          })}
    </>
  );
};

export default Cards;

